"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "2xl:container mx-auto pb-4" };
const _hoisted_2 = { class: "text-2xl print-text-sm pl-5 my-5 font-bold uppercase" };
const _hoisted_3 = { class: "filters justify-between lg:items-end print:hidden" };
const _hoisted_4 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_5 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_6 = { class: "flex items-center justify-center gap-2" };
const _hoisted_7 = { class: "text-center font-bold" };
const _hoisted_8 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_9 = { class: "text-center" };
const _hoisted_10 = { class: "flex gap-2" };
const _hoisted_11 = /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1);
const _hoisted_12 = { class: "" };
const _hoisted_13 = /*#__PURE__*/ (0, vue_2.createElementVNode)("br", null, null, -1);
const _hoisted_14 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_15 = { class: "text-center" };
const _hoisted_16 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_17 = { class: "text-center" };
const _hoisted_18 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_19 = { class: "text-center" };
const _hoisted_20 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_21 = { class: "text-center" };
const _hoisted_22 = { class: "flex items-center justify-center gap-2 text-center" };
const _hoisted_23 = { class: "text-center" };
const _hoisted_24 = ["href"];
const _hoisted_25 = { class: "flex flex-row gap-1 justify-center items-center" };
const _hoisted_26 = ["onClick"];
const _hoisted_27 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-envelope" }, null, -1);
const _hoisted_28 = [
    _hoisted_27
];
const _hoisted_29 = { class: "font-bold text-center mb-3" };
const _hoisted_30 = { class: "flex flex-col lg:flex-row gap-4 justify-center items-center" };
const _hoisted_31 = { class: "flex flex-row gap-4 font-bold uppercase text-sm" };
const _hoisted_32 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_33 = { class: "inline-flex items-center justify-center mb-2" };
const _hoisted_34 = { class: "inline font-bold uppercase text-sm" };
const _hoisted_35 = { class: "inline font-bold uppercase text-sm" };
const _hoisted_36 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_37 = { class: "inline-flex items-center justify-center mb-2" };
const _hoisted_38 = { class: "inline font-bold uppercase text-sm" };
const _hoisted_39 = { class: "inline font-bold uppercase text-sm" };
const _hoisted_40 = { class: "flex justify-center items-center mb-4" };
const _hoisted_41 = { class: "flex justify-center items-center" };
const _hoisted_42 = ["disabled"];
const vue_3 = require("vue");
const shop_1 = require("../../common/utils/shop");
const i18n_1 = require("../../common/i18n");
const ResponsiveTable_vue_1 = __importDefault(require("../../components/ResponsiveTable/ResponsiveTable.vue"));
const Option_1 = __importDefault(require("../../components/Form/Select/Option"));
const ShopInput_vue_1 = __importDefault(require("../../components/Form/ShopInput.vue"));
const Toggle_vue_1 = __importDefault(require("../../components/Form/Toggle.vue"));
const SelectInput_vue_1 = __importDefault(require("../../components/Form/Select/SelectInput.vue"));
const Modal_vue_1 = __importDefault(require("../../components/Modal.vue"));
const vue_router_1 = require("vue-router");
const securityStore_1 = require("../../stores/security/securityStore");
const toastStore_1 = require("../../stores/toast/toastStore");
const AxaptaGuaranteeProductReturnStatusEnum_1 = require("../../models/axaptaGuaranteeProductReturn/AxaptaGuaranteeProductReturnStatusEnum");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
exports.default = (0, vue_1.defineComponent)({
    __name: 'GuaranteeProductReturnList',
    setup(__props) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        const securityStore = (0, securityStore_1.useSecurityStore)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const axaptaGuaranteeProductReturns = (0, vue_3.ref)([]);
        const router = (0, vue_router_1.useRouter)();
        const selectedAxaptaGuaranteeProductReturn = (0, vue_3.ref)(null);
        const defaultFilterStartDate = (0, vue_3.computed)(() => {
            let halfYearBeforeToday = new Date();
            halfYearBeforeToday.setMonth(halfYearBeforeToday.getMonth() - 6);
            return (0, shop_1.formatDate)(halfYearBeforeToday);
        });
        const defaultFilterEndDate = (0, vue_3.computed)(() => {
            return (0, shop_1.formatDate)(new Date());
        });
        const getKeyByValue = (value) => {
            const indexOfStatus = Object.values(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum).indexOf(value);
            return Object.keys(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum)[indexOfStatus];
        };
        const sendGuaranteeProductReturnCopyInEmailModalIsOpen = (0, vue_3.ref)(false);
        const email = (0, vue_3.ref)("");
        const filter = (0, vue_3.ref)({
            startDate: defaultFilterStartDate.value,
            endDate: defaultFilterEndDate.value,
            status: AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ALL,
        });
        const guaranteeProtocol = (0, vue_3.ref)(false);
        const evaluationSheet = (0, vue_3.ref)(false);
        //bírálati lapot csak ezekben az állapotokban küldhet ki
        const evaluationSheetSendStatuses = [
            AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ACCEPTED,
            AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.CLOSED,
            AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.REJECTED,
            AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ESCALATED
        ];
        const guaranteeProductReturnStatusOptions = (0, vue_3.ref)([
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ALL, (_a = (0, i18n_1.trans)("all_status", "All Status", "guarantee_product_return_list")) !== null && _a !== void 0 ? _a : "All Status", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.REGISTERED, (_b = (0, i18n_1.trans)("status_registered", "Registered", "guarantee_product_return_list")) !== null && _b !== void 0 ? _b : "Registered", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.IN_PROCESS, (_c = (0, i18n_1.trans)("status_in_progress", "In Progress", "guarantee_product_return_list")) !== null && _c !== void 0 ? _c : "In Progress", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ACCEPTED, (_d = (0, i18n_1.trans)("status_accepted", "Accepted", "guarantee_product_return_list")) !== null && _d !== void 0 ? _d : "Accepted", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.CLOSED, (_e = (0, i18n_1.trans)("status_closed", "Closed", "guarantee_product_return_list")) !== null && _e !== void 0 ? _e : "Closed", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.REJECTED, (_f = (0, i18n_1.trans)("status_rejected", "Rejected", "guarantee_product_return_list")) !== null && _f !== void 0 ? _f : "Rejected", false),
            new Option_1.default(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum.ESCALATED, (_g = (0, i18n_1.trans)("status_escalated", "Escalated", "guarantee_product_return_list")) !== null && _g !== void 0 ? _g : "Escalated", false),
        ]);
        const listFields = (0, vue_3.ref)([
            {
                key: "id",
                label: (_h = (0, i18n_1.trans)("id", "ID", "guarantee_product_return_list")) !== null && _h !== void 0 ? _h : "ID",
                value: "id",
            },
            {
                key: "createdDate",
                label: (_j = (0, i18n_1.trans)("created_date", "Created Date", "guarantee_product_return_list")) !== null && _j !== void 0 ? _j : "Created Date",
                value: "createdDate",
            },
            {
                key: "productName",
                label: (_k = (0, i18n_1.trans)("product_name", "Product Name", "guarantee_product_return_list")) !== null && _k !== void 0 ? _k : "Product Name",
                value: "productName",
            },
            {
                key: "status",
                label: (_l = (0, i18n_1.trans)("status", "Status", "guarantee_product_return_list")) !== null && _l !== void 0 ? _l : "Status",
                value: "status",
            },
            {
                key: "percent",
                label: (_m = (0, i18n_1.trans)("percent", "Percent", "guarantee_product_return_list")) !== null && _m !== void 0 ? _m : "Percent",
                value: "percent",
            },
            {
                key: "invoiceId",
                label: (_o = (0, i18n_1.trans)("invoice_id", "Invoice Id", "guarantee_product_return_list")) !== null && _o !== void 0 ? _o : "Invoice Id",
                value: "invoiceId",
            },
            {
                key: "invoiceDate",
                label: (_p = (0, i18n_1.trans)("invoice_date", "Invoice Date", "guarantee_product_return_list")) !== null && _p !== void 0 ? _p : "Invoice Date",
                value: "invoiceDate",
            },
            {
                key: "imagesLink",
                label: (_q = (0, i18n_1.trans)("images", "Images", "guarantee_product_return_list")) !== null && _q !== void 0 ? _q : "Images",
                value: "imagesLink",
            },
            {
                key: "actions",
                label: "",
            },
        ]);
        const printPage = () => {
            window.print();
        };
        const queryGuaranteeProductReturns = () => {
            var _a;
            if (securityStore.authenticatedUser === null) {
                toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_authenticated_user", "There is no authenticated user", "guarantee_product_return_list")) !== null && _a !== void 0 ? _a : "There is no authenticated user");
                return;
            }
            if (filter.value.startDate === "") {
                filter.value.startDate = defaultFilterStartDate.value;
            }
            if (filter.value.endDate === "") {
                filter.value.endDate = defaultFilterEndDate.value;
            }
            getGuaranteeProductReturns(router, filter.value, securityStore.authenticatedUser.customer.id);
        };
        const openSendingGuaranteeProductReturnCopyInEmailModal = (axaptaGuaranteeProductReturnInterface) => {
            selectedAxaptaGuaranteeProductReturn.value =
                axaptaGuaranteeProductReturnInterface;
            sendGuaranteeProductReturnCopyInEmailModalIsOpen.value = true;
        };
        const sendGuaranteeProductReturnCopyInEmail = async () => {
            var _a, _b;
            if (confirm((_a = (0, i18n_1.trans)("send_guarantee_product_return_copy_in_email_confirm", `Are you really want to send guarantee product return copy to {email}`, "guarantee_product_return_list", { email: email.value })) !== null && _a !== void 0 ? _a : `Are you really want to send guarantee product return copy to {email}`)) {
                if (((_b = selectedAxaptaGuaranteeProductReturn.value) === null || _b === void 0 ? void 0 : _b.id) == null) {
                    return;
                }
                try {
                    await sendGuaranteeProductReturnCopyInEmailApi(router, {
                        email: email.value,
                        guaranteeProtocol: guaranteeProtocol.value,
                        evaluationSheet: evaluationSheet.value,
                        id: selectedAxaptaGuaranteeProductReturn.value.id
                    });
                    sendGuaranteeProductReturnCopyInEmailModalIsOpen.value = false;
                    toastStore.addToast({
                        message: (0, i18n_1.trans)("email_sent_successfully", "Email is sent successfully!", "guarantee_product_return_list"),
                        type: "success",
                        timer: 5,
                    });
                }
                catch (error) {
                    toastStore.addErrorToast(error.toString());
                }
            }
        };
        const getGuaranteeProductReturns = async (router, params, customerId) => {
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_guarantee_product_returns_api", query: { customerId: customerId, ...params } }).href);
                let result = [];
                if (Array.isArray(response)) {
                    result = response;
                }
                axaptaGuaranteeProductReturns.value = result;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const sendGuaranteeProductReturnCopyInEmailApi = async (router, payload) => {
            let options = { body: JSON.stringify(payload), method: "POST" };
            try {
                const response = await (0, fetch_1.default)(router.resolve({ name: "axapta_send_guarantee_product_return_copy_in_email_api" }).href, options);
                if (response.status !== "success") {
                    throw response.error;
                }
                return response;
            }
            catch (error) {
                console.error("Error sending guarantee product return copy in email:", error);
                throw error;
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("guarantee_product_return_list", "Complaint List", "guarantee_product_return_list")), 1),
                (0, vue_2.createElementVNode)("div", _hoisted_3, [
                    (0, vue_2.createElementVNode)("div", _hoisted_4, [
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('start_date_placeholder', 'Start Date', 'guarantee_product_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('start_date_label', 'Start Date', 'guarantee_product_return_list'),
                            modelValue: filter.value.startDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((filter.value.startDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('end_date_placeholder', 'End Date', 'guarantee_product_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('end_date_label', 'End Date', 'guarantee_product_return_list'),
                            modelValue: filter.value.endDate,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((filter.value.endDate) = $event)),
                            type: "date",
                            required: "",
                            border: ""
                        }, null, 8, ["placeholder", "label", "modelValue"]),
                        (0, vue_2.createVNode)(SelectInput_vue_1.default, {
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('status', 'Status', 'guarantee_product_return_list'),
                            label: (0, vue_2.unref)(i18n_1.trans)('status', 'Status', 'guarantee_product_return_list'),
                            class: "w-full",
                            modelValue: filter.value.status,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((filter.value.status) = $event)),
                            required: "",
                            border: "",
                            options: guaranteeProductReturnStatusOptions.value
                        }, null, 8, ["placeholder", "label", "modelValue", "options"])
                    ]),
                    (0, vue_2.createElementVNode)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-warning h-[48px]",
                            onClick: _cache[3] || (_cache[3] = ($event) => (printPage()))
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("print", "Print", "customer_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("button", {
                            class: "btn btn-rounded btn-primary h-[48px]",
                            onClick: queryGuaranteeProductReturns
                        }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("submit_query", "Submit Query", "guarantee_product_return_list")), 1)
                    ])
                ]),
                (0, vue_2.createVNode)(ResponsiveTable_vue_1.default, {
                    fields: listFields.value,
                    "onUpdate:fields": _cache[4] || (_cache[4] = ($event) => ((listFields).value = $event)),
                    items: axaptaGuaranteeProductReturns.value,
                    striped: "",
                    condensed: "",
                    panel: ""
                }, {
                    "head-id": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("id", "ID", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-id": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.id), 1)
                    ]),
                    "head-createdDate": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_8, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("created_date", "Created Date", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-createdDate": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_9, (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.createdDate), 1)
                    ]),
                    "head-productName": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_10, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("product_name", "Product Name", "guarantee_product_return_list")), 1),
                            _hoisted_11,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("error", "Error", "guarantee_product_return_list")), 1)
                        ])
                    ]),
                    "cell-productName": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_12, [
                            (0, vue_2.createTextVNode)((0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.productName), 1),
                            _hoisted_13,
                            (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.error), 1)
                        ])
                    ]),
                    "head-status": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("status", "Status", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-status": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)(getKeyByValue(axaptaGuaranteeProductReturn.status), getKeyByValue(axaptaGuaranteeProductReturn.status), "guarantee_product_return_list")), 1)
                    ]),
                    "head-percent": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("percent", "Percent", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-percent": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_17, (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.percent) + " % ", 1)
                    ]),
                    "head-invoiceId": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_id", "Invoice Id", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-invoiceId": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.invoiceId), 1)
                    ]),
                    "head-invoiceDate": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_20, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("invoice_date", "Invoice Date", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-invoiceDate": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)(axaptaGuaranteeProductReturn.invoiceDate), 1)
                    ]),
                    "head-imagesLink": (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_22, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("images", "Images", "guarantee_product_return_list")), 1)
                    ]),
                    "cell-imagesLink": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_23, [
                            (axaptaGuaranteeProductReturn.imagesLink !== '')
                                ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("a", {
                                    key: 0,
                                    href: axaptaGuaranteeProductReturn.imagesLink,
                                    target: "_blank",
                                    class: "btn btn-rounded btn-primary btn-link"
                                }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("images", "Images", "guarantee_product_return_list")), 9, _hoisted_24))
                                : (0, vue_2.createCommentVNode)("", true)
                        ])
                    ]),
                    "cell-actions": (0, vue_2.withCtx)(({ item: axaptaGuaranteeProductReturn }) => [
                        (0, vue_2.createElementVNode)("div", _hoisted_25, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-danger btn-link",
                                onClick: ($event) => (openSendingGuaranteeProductReturnCopyInEmailModal(axaptaGuaranteeProductReturn))
                            }, _hoisted_28, 8, _hoisted_26)
                        ])
                    ]),
                    _: 1
                }, 8, ["fields", "items"]),
                (0, vue_2.createVNode)(Modal_vue_1.default, {
                    isOpen: sendGuaranteeProductReturnCopyInEmailModalIsOpen.value,
                    title: selectedAxaptaGuaranteeProductReturn.value !== null
                        ? (0, vue_2.unref)(i18n_1.trans)('send_guarantee_product_return_copy_in_email', 'Send Guarantee Product Return Copy In Email - ID: {id}', 'guarantee_product_return_list', { id: selectedAxaptaGuaranteeProductReturn.value.id })
                        : '',
                    onClose: _cache[8] || (_cache[8] = ($event) => (sendGuaranteeProductReturnCopyInEmailModalIsOpen.value = false))
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("selected_documents_copy_can_be_sent_in_pdf", "The selected documents copy can be sent in PDF format to the given email address.", "guarantee_product_return_list")), 1),
                        (0, vue_2.createElementVNode)("div", _hoisted_30, [
                            (0, vue_2.createElementVNode)("div", _hoisted_31, [
                                (0, vue_2.createElementVNode)("div", _hoisted_32, [
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("guarantee_protocol", "Guarantee Protocol", "guarantee_product_return_list")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_34, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("guarantee_protocol_no", "No", "guarantee_product_return_list")), 1),
                                        (selectedAxaptaGuaranteeProductReturn.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                                                key: 0,
                                                modelValue: guaranteeProtocol.value,
                                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((guaranteeProtocol).value = $event)),
                                                class: "mx-3",
                                                disabled: selectedAxaptaGuaranteeProductReturn.value.status == (0, vue_2.unref)(AxaptaGuaranteeProductReturnStatusEnum_1.AxaptaGuaranteeProductReturnStatusEnum).ALL
                                            }, null, 8, ["modelValue", "disabled"]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("guarantee_protocol_yes", "Yes", "guarantee_product_return_list")), 1)
                                    ])
                                ]),
                                (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                    (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("evaluation_sheet", "Evaluation Sheet", "guarantee_product_return_list")), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_37, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("evaluation_sheet_no", "No", "guarantee_product_return_list")), 1),
                                        (selectedAxaptaGuaranteeProductReturn.value)
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(Toggle_vue_1.default, {
                                                key: 0,
                                                modelValue: evaluationSheet.value,
                                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((evaluationSheet).value = $event)),
                                                class: "mx-3",
                                                disabled: !evaluationSheetSendStatuses.includes(selectedAxaptaGuaranteeProductReturn.value.status)
                                            }, null, 8, ["modelValue", "disabled"]))
                                            : (0, vue_2.createCommentVNode)("", true),
                                        (0, vue_2.createElementVNode)("div", _hoisted_39, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("evaluation_sheet_yes", "Yes", "guarantee_product_return_list")), 1)
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_40, [
                                (0, vue_2.createVNode)(ShopInput_vue_1.default, {
                                    placeholder: (0, vue_2.unref)(i18n_1.trans)('email_address', 'Email address', 'guarantee_product_return_list'),
                                    modelValue: email.value,
                                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((email).value = $event)),
                                    class: "w-[300px]",
                                    type: "email",
                                    required: "",
                                    border: ""
                                }, null, 8, ["placeholder", "modelValue"])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_41, [
                            (0, vue_2.createElementVNode)("button", {
                                class: "btn btn-rounded btn-primary inline",
                                onClick: sendGuaranteeProductReturnCopyInEmail,
                                disabled: !(guaranteeProtocol.value || evaluationSheet.value)
                            }, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("send_email", "Send Email", "guarantee_product_return_list")), 9, _hoisted_42)
                        ])
                    ]),
                    _: 1
                }, 8, ["isOpen", "title"])
            ]));
        };
    }
});
